import { createSlice } from '@reduxjs/toolkit';

export const INITIAL_STATE = {
  user: null,
  isLoading: false,
  isInitialLoading: true,
  error: null,
  resetRequested: false,
  // resetError: { message: string, field?: 'password' } | null
  // Surfaced on the /reset-password page; field-targeted errors render
  // inline on the corresponding form input, others render as a banner.
  resetError: null,
  sessionGeneration: 0,
  sessionPending: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState: {
    ...INITIAL_STATE,
  },
  reducers: {
    signInRequest(state) {
      state.sessionGeneration += 1;
      state.sessionPending = true;
      state.isLoading = true;
    },
    signInSuccess(state, action) {
      return {
        ...state,
        sessionGeneration: state.sessionGeneration + 1,
        sessionPending: false,
        user: action.payload.user,
        isLoading: false,
        error: null,
      };
    },
    meRequest(state) {
      state.isLoading = true;
    },
    meSuccess(state, action) {
      return {
        ...state,
        user: action.payload.user,
        isLoading: false,
        error: null,
      };
    },
    initialLoadRequest(state) {
      state.isInitialLoading = true;
    },
    initialLoadUnauthenticated(state) {
      state.isInitialLoading = false;
    },
    initialLoadSuccess(state, action) {
      return {
        ...state,
        sessionGeneration: state.sessionGeneration + 1,
        sessionPending: false,
        user: action.payload.user,
        isLoading: false,
        isInitialLoading: false,
        error: null,
      };
    },
    error(state, action) {
      state.error = action?.payload?.message || 'Unkown Error';
      state.isLoading = false;
      state.isInitialLoading = false;
    },
    clearErrors(state) {
      state.error = null;
      state.isLoading = false;
      state.isInitialLoading = false;
    },
    logoutRequest(state) {
      state.sessionGeneration += 1;
      state.sessionPending = true;
    },
    logoutSuccess(state) {
      return {
        ...INITIAL_STATE,
        sessionGeneration: state.sessionGeneration + 1,
        isInitialLoading: false,
      };
    },
    forgotPasswordRequest(state) {
      state.isLoading = true;
    },
    forgotPasswordSuccess(state) {
      return {
        ...state,
        isLoading: false,
        error: null,
        resetRequested: true,
      };
    },
    resetPasswordRequest(state) {
      state.isLoading = true;
      state.resetError = null;
    },
    resetPasswordSuccess(state) {
      return {
        ...state,
        isLoading: false,
        error: null,
        resetError: null,
        resetRequested: false,
      };
    },
    resetPasswordFailure(state, action) {
      state.isLoading = false;
      state.resetError = action.payload || { message: 'Unable to reset password' };
    },
  },
});

export const {
  signInRequest,
  signInSuccess,
  logoutRequest,
  logoutSuccess,
  error,
  meRequest,
  meSuccess,
  initialLoadRequest,
  initialLoadSuccess,
  initialLoadUnauthenticated,
  clearErrors,
  forgotPasswordRequest,
  forgotPasswordSuccess,
  resetPasswordRequest,
  resetPasswordSuccess,
  resetPasswordFailure,
} = userSlice.actions;

export default userSlice.reducer;
